import { consoleMsg, waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous, prefillVendorDates, showDiv, hideDiv } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk, renderQuestionOkNotOkDate } from "../shared/templates.js";

const app = window.app;

export class Glovebox extends HTMLElement {
	async connectedCallback() {
		await waitForContent("glovebox");
		this.innerHTML = app.content.glovebox;

		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton3", "nextButton3"));

		this.querySelector("#monroney-slot").replaceWith(renderQuestionOkNotOk("monroney", "Monroney in vehicle", 3));
		this.querySelector("#incident-slot").replaceWith(renderQuestionOkNotOk("incident", "Incident form in vehicle", 3));
		this.querySelector("#insurance-slot").replaceWith(renderQuestionOkNotOkDate("insurance", "Vehicle insurance card", "Vehicle insurance date:", 3));
		this.querySelector("#registration-slot").replaceWith(renderQuestionOkNotOkDate("registration", "Vehicle registration card", "Vehicle registration date:", 3));

		/* Radio, date and alert listeners are bound here rather than in ionViewDidEnter:
		that event fires on every entry to the page, so the listeners accumulate on the same
		elements and each handler runs once per accumulated listener — which would present the
		date alert repeatedly. connectedCallback runs once per element. */
		const dateAlert = document.getElementById("dateClearAlert");
		dateAlert.buttons = [
			{ text: "Cancel", role: "cancel" },
			{ text: "OK", role: "confirm" },
		];

		dateAlert.addEventListener("ionAlertDidDismiss", (ev) => {
			const name = dateAlert.data?.name;
			if (!name) return;

			if (ev.detail.role === "confirm") {
				document.getElementById(`${name}-date`).value = undefined;
				localStorage.removeItem(`${name}-date`);
				app.state[`${name}DateModified`] = false;
				hideDiv(`${name}-div`);
				consoleMsg(`${name} date cleared by user`);
			} else {
				// Cancel — put the answer back to OK and re-show the date
				document.getElementById(`${name}-group`).value = "OK";
				document.getElementById(`${name}-radio-ok`).checked = true;
				showDiv(`${name}-div`);
			}
		});

		for (const name of ["insurance", "registration"]) {
			document.getElementById(`${name}-radio-ok`).addEventListener("click", () => showDiv(`${name}-div`));

			// Answering Not OK with a date already entered warns before discarding it
			document.getElementById(`${name}-radio-notok`).addEventListener("click", () => {
				const dateEl = document.getElementById(`${name}-date`);
				if (dateEl?.value) {
					dateAlert.data = { name: name };
					dateAlert.present();
				} else {
					hideDiv(`${name}-div`);
				}
			});

			document.getElementById(`${name}-date`).addEventListener("ionChange", () => {
				app.state[`${name}DateModified`] = true;
				consoleMsg(`${name} date modified by user`);
			});
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(3, pageElement);
		});
		this.addEventListener("ionViewDidEnter", async () => {
			await customElements.whenDefined("ion-datetime");

			prefillVendorDates();

			const currentRoute = app.routes.glovebox;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));

			// The date row shows only when NAVS supplied a date or the user answers OK.
			// A NAVS-supplied date also answers OK on the user's behalf.
			for (const name of ["insurance", "registration"]) {
				const group = document.getElementById(`${name}-group`);
				const dateEl = document.getElementById(`${name}-date`);

				// Seed OK only when the user has no answer of their own yet, so a
				// later change to Not OK survives coming back to the page
				if (app.data?.navsData?.[`${name}Date`] && group && !group.value) {
					group.value = "OK";
					document.getElementById(`${name}-radio-ok`).checked = true;
				}

				// restoreFromLocalStorage reveals the date row for any stored answer — correct that here
				if (group?.value === "OK") {
					showDiv(`${name}-div`);
				} else {
					hideDiv(`${name}-div`);
					// A cleared date must stay cleared: prefillVendorDates re-seeds from NAVS
					// once the stored key is gone
					if (dateEl) dateEl.value = undefined;
				}
			}
		});
	}
}
